export class DriveTypes {
  static FWD: string = "FWD";
  static FF: string = "FF";
  static FR: string = "FR";
  static MR: string = "MR";
  static RR: string = "RR";

}
